const units = [
  { field: 'adRea', index: 1000 },
  { field: 'adMed', index: 1001 },
  { field: 'adMedCan', index: 40, main: true },
  { field: 'adMedCan', index: 2000, sub: true },
  { field: 'adMedRad', index: 54, main: true },
  { field: 'adMedRad', index: 2001, sub: true },
  { field: 'adMedHem', index: 45, main: true },
  { field: 'adMedHem', index: 2002, sub: true },
  { field: 'adUrg', index: 1002 },
  { field: 'adChir', index: 1003 },
  { field: 'adChirTra', index: 33, add: true },
  { field: 'adObs', index: 1004 },
  { field: 'adSSR', index: 1005 },
  { field: 'adPsy', index: 1006 },
  { field: 'adDia', index: 1007, type: 'dia' },
  { field: 'adHAD', index: 1008, type: 'had' },
  { field: 'adSLD', index: 1009 },
  { field: 'adEHP', index: 1010 },
  { field: 'pedRea', index: 1100 },
  { field: 'pedMed', index: 1101 },
  { field: 'pedMedCan', index: 69, main: true },
  { field: 'pedMedCan', index: 2100, sub: true },
  { field: 'pedUrg', index: 1102 },
  { field: 'pedChir', index: 1103 },
  { field: 'pedSSR', index: 1104 },
  { field: 'pedPsy', index: 1105 },
  { field: 'pedDia', index: 1106, type: 'dia' },
  { field: 'pedHAD', index: 1107, type: 'had' },
  { field: 'pedSLD', index: 1108 },
  { field: 'neoRea', index: 1200 },
  { field: 'neoMed', index: 1201 },
  { field: 'neoUrg', index: 1202 },
  { field: 'neoChir', index: 1203 },
  { field: 'mixRea', index: 1300 }
]

const neocat = [
  { f: '920100021', uf: '0700' },
  { f: '920100047', uf: 'REA NEONAT' },
  { f: '920100047', uf: 'SI NEONAT' },
  { f: '930000328', uf: 'Néonat' },
  { f: '940100043', uf: '010629' },
  { f: '540023264', uf: '6253' },
  { f: '970400024', uf: 'Réa Néo' },
  { f: '690782222', uf: '0403 et 0404' }
]

const rezo = [
  { f: '750000523', uf: '6401' },
  { f: '780800256', uf: '5400' },
  { f: '370000085', uf: 'Réanimation' },
  { f: '130789316', uf: '2000' },
  { f: '140017237', uf: 'Réa chirurgicale' },
  { f: '090000175', uf: 'Réa polyvalente' },
  { f: '500000112', uf: '2600' },
  { f: '920100021', uf: '371' },
  { f: '920000650', uf: '426' },
  { f: '440000057', uf: '3805' },
  { f: '670780345', uf: '3005' },
  { f: '970400057', uf: '8490, NeuroRéa' },
  { f: '380780049', uf: 'UF146' },
  { f: '510024979', uf: 'REA' },
  { f: '940000573', uf: '1231' },
  { f: '150000040', uf: 'Réanimation' },
  { f: '690805361', uf: '1C19' },
  { f: '690783154', uf: '21187' },
  { f: '440000289', uf: '3810' },
  { f: '930110069', uf: '5501' },
  { f: '620101360', uf: '3500' },
  { f: '320780117', uf: '2105' },
  { f: '610780082', uf: '3101' },
  { f: '930000328', uf: 'adulte' },
  { f: '810000331', uf: '2002' },
  { f: '560000135', uf: '4364' },
  { f: '620100685', uf: 'Réanimation polyvalente' },
  { f: '590781902', uf: '2712' },
  { f: '660780784', uf: ' réa adultes' },
  { f: '940100043', uf: '010146' },
  { f: '130780521', uf: 'Réa Polyvalente :UF 2152' },
  { f: '820000057', uf: 'REANIMATION' },
  { f: '820000032', uf: '2700' },
  { f: '300000114', uf: 'rea' },
  { f: '170780175', uf: '7000' },
  { f: '590781415', uf: '7100' },
  { f: '540023264', uf: '1223' },
  { f: '540023264', uf: '2471' },
  { f: '290000728', uf: '920' },
  { f: '750150237', uf: 'Réanimation' },
  { f: '330781303', uf: '9REA' },
  { f: '760024042', uf: 'réanimation polyvalente' },
  { f: '510000029', uf: '2520' },
  { f: '130784713', uf: 'POL' },
  { f: '650783160', uf: 'Réa' },
  { f: '130789274', uf: '0100' },
  { f: '130785678', uf: 'Réanimation polyvalente' },
  { f: '2A0000014', uf: ' 4001: REA POLYV ' },
  { f: '710978263', uf: '7551' },
  { f: '060789195', uf: '7620' }
]

const columns = [
  { key: 'finess', header: 'finess' },
  { key: 'establishment', header: 'nom' },
  { key: 'AllReaTotalBeds', header: 'total lits (réa)' },
  { key: 'AllReaWatchedBeds', header: 'total lits surveillés (réa)' },
  { key: 'AllReaWatchedEntrances', header: 'total admissions (réa)' },
  { key: 'AllReaWatchedHospit', header: 'total hospit surveillées (réa)' },
  { key: 'TotalReaSheetsCount', header: 'total fiches réa' },
  { key: 'TotalReaUnitsCount', header: 'nb de services de réa avec fiches' },
  { key: 'bactADI', header: 'bactADI' },
  { key: 'bactADIStart', header: 'début bactADI' },
  { key: 'bactADIEnd', header: 'fin bactADI' },
  { key: 'bactADICount', header: 'fiches bactADI' },
  { key: 'bactADIReaSheetsCount', header: 'fiches bactADI (Réa)' },
  { key: 'bactADIReaUnitsCount', header: 'services réa fiches bactADI' },
  { key: 'reaBactADI', header: 'reaBactADI' },
  { key: 'reaBactADIStart', header: 'début reaBactADI' },
  { key: 'reaBactADIEnd', header: 'fin reaBactADI' },
  { key: 'reaBactADICount', header: 'fiches reaBactADI' },
  { key: 'reaBactADIDetail', header: 'detail reaBactADI' },
  { key: 'reaBactADIReaSheetsCount', header: 'fiches reaBactADI (Réa)' },
  { key: 'reaBactADIReaUnitsCount', header: 'services réa fiches reaBactADI' },
  { key: 'reaInfADI', header: 'reaInfADI' },
  { key: 'reaInfADIStart', header: 'début reaInfADI' },
  { key: 'reaInfADIEnd', header: 'fin reaInfADI' },
  { key: 'reaInfADICount', header: 'fiches reaInfADI' },
  { key: 'reaInfADIDetail', header: 'detail reaInfADI' },
  { key: 'reaInfADIReaSheetsCount', header: 'fiches reaInfADI (Réa)' },
  { key: 'reaInfADIReaUnitsCount', header: 'services réa fiches reaInfADI' },
  { key: 'rezoCount', header: 'fiches REZO' },
  { key: 'rezoDetail', header: 'detail REZO' },
  { key: 'rezoReaSheetsCount', header: 'fiches rezo (Réa)' },
  { key: 'rezoReaUnitsCount', header: 'services réa fiches rezo' },
  { key: 'neoInfADI', header: 'neoInfADI' },
  { key: 'neoInfADIStart', header: 'début neoInfADI' },
  { key: 'neoInfADIEnd', header: 'fin neoInfADI' },
  { key: 'neoInfADICount', header: 'fiches neoInfADI' },
  { key: 'neoInfADIDetail', header: 'detail neoInfADI' },
  { key: 'neoInfADIReaSheetsCount', header: 'fiches neoInfADI (Réa)' },
  { key: 'neoInfADIReaUnitsCount', header: 'services réa fiches neoInfADI' },
  { key: 'neocatCount', header: 'fiches NEOCAT' },
  { key: 'neocatDetail', header: 'detail NEOCAT' },
  { key: 'neocatReaSheetsCount', header: 'fiches neocat (Réa)' },
  { key: 'neocatReaUnitsCount', header: 'services réa fiches neocat' },
  { key: 'diaInfADI', header: 'diaInfADI' },
  { key: 'diaInfADIStart', header: 'début diaInfADI' },
  { key: 'diaInfADIEnd', header: 'fin diaInfADI' },
  { key: 'diaInfADICount', header: 'fiches diaInfADI' },
  { key: 'diaInfADIDetail', header: 'detail diaInfADI' },
  { key: 'status', header: 'statut' },
  { key: 'chart', header: 'charte' },
  { key: 'denominatorsStatus', header: 'statut fiche' },
  { key: 'denominatorsVersion', header: 'version fiche' },
  { key: 'establishmentStatus', header: 'statut étab' },
  { key: 'establishmentType', header: 'type étab' },
  { key: 'flasks2018', header: 'hemoc 2018' },
  { key: 'flasks2019', header: 'hemoc surv' }
]

units.forEach(
  u => {
    if (u.type === 'had') {
      columns.push({
        key: `${u.field}ActiveQueue`,
        header: `queue ${u.field}`
      })
      columns.push({
        key: `${u.field}Hospit`,
        header: `hospit ${u.field}`
      })

      columns.push({
        key: `${u.field}WatchedActiveQueue`,
        header: `queue surv ${u.field}`
      })
    } else {
      if (!u.sub) {
        columns.push({
          key: `${u.field}TotalBeds`,
          header: `lits ${u.field}`
        })
      }

      if (!u.main) {
        columns.push({
          key: `${u.field}WatchedBeds`,
          header: `lits surv ${u.field}`
        })

        columns.push({
          key: `${u.field}WatchedEntrances`,
          header: `admissions ${u.field}`
        })
      }
    }

    if (u.type === 'dia') {
      columns.push({
        key: `${u.field}WatchedDialysisCount`,
        header: `séances ${u.field}`
      })
    } else if (!u.main) {
      columns.push({
        key: `${u.field}WatchedHospit`,
        header: `hospit surv ${u.field}`
      })
    }
  }
)

function setValue (result, u, suffix, value) {
  const field = `${u.field}${suffix}`
  if (!u.add || result[field] == null) {
    result[field] = value
  } else {
    result[field] += value
  }
}

function newDate (date) {
  if (date == null || date === '') {
    return null
  }

  const value = new Date(date)
  if (value.getFullYear() > 1) {
    const options = {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }
    const str = value.toLocaleDateString('fr-FR', options)
    return str.replace(/[^0-9/]+/g, '')
  }
  return null
}

function isRea (type) {
  return [1, 2, 3, 4, 5, 6, 7, 11, 14, 17].indexOf(type) !== -1
}

function collectModalities (result, s, c) {
  const protocols = [
    'bactADI',
    'reaBactADI',
    'neoInfADI',
    'reaInfADI',
    'diaInfADI'
  ]

  for (let i in protocols) {
    const p = protocols[i]
    result[`${p}`] = s.source.protocols[p]
    result[`${p}Start`] = newDate(s.source.per[p].start)
    result[`${p}End`] = newDate(s.source.per[p].end)
  }

  protocols.push('rezo')
  protocols.push('neocat')

  const finess = s.source.establishment.finess
  const r = rezo.filter(r => finess === r.f)
  if (r.length > 0) {
    r.forEach(
      u => {
        c.forEach(
          i => {
            if (i.protocol === 'reaInfADI' && i.uf === u.uf) {
              i.protocol = 'rezo'
            }
          }
        )
      }
    )
  }

  const n = neocat.filter(r => finess === r.f)
  if (n.length > 0) {
    n.forEach(
      u => {
        c.forEach(
          i => {
            if (i.protocol === 'neoInfADI' && i.uf === u.uf) {
              i.protocol = 'neocat'
            }
          }
        )
      }
    )
  }

  let rea = {
    sheets: 0,
    units: 0
  }
  for (let i in protocols) {
    const p = protocols[i]
    const counts = c.filter(
      e => e.s === s.source.id && e.protocol === p
    )
    if (counts.length > 0) {
      let sum = 0
      let reaSum = 0
      let unitsRea = 0
      let detail = ''
      counts.forEach(c => {
        if (sum !== 0) {
          detail += ', '
        }
        detail += `${c.uf} (${c.count})`
        sum += c.count
        if (isRea(c.unitType)) {
          rea.sheets += c.count
          rea.units += 1
          reaSum += c.count
          unitsRea += 1
        }
      })
      result[`${p}Count`] = sum
      result[`${p}Detail`] = detail
      result[`${p}ReaSheetsCount`] = reaSum
      result[`${p}ReaUnitsCount`] = unitsRea
    }
  }
  result[`TotalReaSheetsCount`] = rea.sheets
  result[`TotalReaUnitsCount`] = rea.units

  if (s.source.emptyBactADI) {
    result[`bactADICount`] = 0
  }
}

function createExportedSurveillance (s, d, c) {
  const result = {
    finess: s.source.establishment.finess,
    establishment: s.source.establishment.name,
    chart: s.source.cvt.stat
  }

  collectModalities(result, s, c)

  if (d != null) {
    result.denominatorsStatus = d.st
    result.denominatorsVersion = d.v
    result.establishmentStatus = d.f.es
    result.establishmentType = d.f.et
    result.flasks2018 = d.f.hly
    result.flasks2019 = d.f.hs
    units.forEach(
      u => {
        const unit = d.f.d.find(r => r.type === u.index)
        if (unit != null) {
          if (u.type === 'had') {
            result[`${u.field}ActiveQueue`] = unit.info.activeQueue
            result[`${u.field}Hospit`] = unit.info.hospit
          } else if (!u.sub) {
            result[`${u.field}TotalBeds`] = unit.info.beds
          }
        }

        if (u.main) {
          return
        }

        let found = false
        for (let i in d.f.a) {
          const watched = d.f.a[i]
          if (watched.type !== u.index) {
            continue
          }

          if (!u.add && found) {
            throw new Error(
              `Found duplicated unit ${unit.code}.`
            )
          }
          found = true
          if (u.type === 'had') {
            setValue(result, u, 'WatchedActiveQueue', watched.info.activeQueue)
          } else {
            setValue(result, u, 'WatchedBeds', watched.info.beds)
            setValue(result, u, 'WatchedEntrances', watched.info.admissions)
          }
          if (u.type === 'dia') {
            setValue(result, u, 'WatchedDialysisCount', watched.info.dialysis)
          } else {
            setValue(result, u, 'WatchedHospit', watched.info.hospit)
          }
        }
      }
    )
    const reaFields = [
      'TotalBeds', 'WatchedBeds', 'WatchedEntrances', 'WatchedHospit'
    ]
    reaFields.forEach(
      f => {
        const field = `AllRea${f}`
        result[field] = 0
        const spe = [ 'adRea', 'pedRea', 'neoRea', 'mixRea' ]
        spe.forEach(
          r => {
            const value = result[`${r}${f}`]
            if (value != null) {
              result[field] += value
            }
          }
        )
      }
    )
  }
  return result
}

const cast = {
  boolean: function (b) {
    return { value: b ? 'Oui' : 'Non', quote: false }
  },

  string: function (v, ctx) {
    switch (ctx.column) {
      case 'chart':
        if (v === 2) {
          return 'validée'
        } else if (v === 3) {
          return 'refusée'
        } else if (v === 1) {
          return 'en attente'
        } else if (v === 4) {
          return 'en attente du fichier'
        } else {
          return 'manquante'
        }

      case 'denominatorsStatus':
        if (v === 'valid') { return 'validée' }
        return 'ouverte'
    }
    return v
  },

  number: function (v, ctx) {
    switch (ctx.column) {
      case 'establishmentStatus':
        switch (v) {
          case 1: return 'Public'
          case 2: return 'ESPIC'
          case 3: return 'Privé'
        }
        break
      case 'establishmentType':
        switch (v) {
          case 1: return 'CHRU/CHR'
          case 2: return 'CH'
          case 3: return 'CH (ex-HL)'
          case 4: return 'HA'
          case 5: return 'CLCC'
          case 6: return 'Clinique MCO'
          case 7: return 'SSR'
          case 8: return 'SLD'
          case 9: return 'PSY'
          case 10: return 'HAD'
          case 11: return 'DIA'
          case 12: return 'EHP'
        }
        break
    }
    return `${v}`
  }
}
export default {
  createExportedSurveillance: createExportedSurveillance,
  columns: columns,
  cast: cast
}
